import React, { forwardRef } from "react";
import "./salesEstimator.css";
import EngineTool from "./EngineTool";
import markup from "../../lib/salesEstimatorMarkup";
import { mountSalesEstimator } from "../../lib/salesEstimatorEngine";

// Native Financial Projection Tool — snapshot format unchanged (every input id + __activeTab).
const SalesEstimatorTool = forwardRef(function SalesEstimatorTool({ onSave }, ref) {
  return <EngineTool ref={ref} markup={markup} mount={mountSalesEstimator} className="se-native"
    testid="sales-estimator-native" onSave={onSave} />;
});

export default SalesEstimatorTool;
